import { v4 as uuid } from "uuid";

 import {
   boneChew,
   dentastix,
   duoStick,
   mini,
   sara,
   yummy,
 } from "../../assets/images"

export const products = [
  {
    _id: uuid(),
    name: "Dogsee Chew",
    title: "Dogsee Chew",
    img: boneChew,
    productDesc: "The perfect long-lasting dog chew sticks for puppies and small breed fluffies!",
    textBadge: "Trending",
    rating: "4.0 ",
    reviews: "8.6K reviews",
    price: 99,
    discountedPrice: 500,
    initialPrice: 599,
    categoryName: "puppy",
    brand: "petmate",
  },
  {
    _id: uuid(),
    name: "Apple & Banana Biscuits",
    title: "Apple & Banana Biscuits",
    img: yummy,
    productDesc: "Made with real Apples & Bananas, free of Gluten & Artificial Flavours. Suitable for all Dogs",
    textBadge: "Best Seller",
    rating: "4.2 ",
    reviews: "6.2K reviews",
    price: 299,
    discountedPrice: 500,
    initialPrice: 799,
    categoryName: "puppy",
    brand: "purina"
  },
  {
    _id: uuid(),
    name: "Duo Stick",
    title: "Duo Stick",
    img: duoStick,
    productDesc: "Made with real Apples & Bananas, free of Gluten & Artificial Flavours. Suitable for all Dogs",
    textBadge: "Few Left",
    rating: "4.6 ",
    reviews: "12.3K reviews",
    price: 499,
    discountedPrice: 700,
    initialPrice: 1199,
    categoryName: "senior",
    brand: "kong"
  },
  {
    _id: uuid(),
    name: "Mini's MaM",
    title: "Mini's MaM",
    img: mini,
    productDesc: "Made with real Apples & Bananas, free of Gluten & Artificial Flavours. Suitable for all Dogs",
    textBadge: "Few Left",
    rating: "4.6 ",
    reviews: "12.3K reviews",
    price: 99,
    discountedPrice: 100,
    initialPrice: 299,
    categoryName: "adult",
    brand: "bayer",
  },
  {
    _id: uuid(),
    name: "Sara's Jerky",
    title: "Sara's Jerky",
    img: sara,
    productDesc: "Made with real Apples & Bananas, free of Gluten & Artificial Flavours. Suitable for all Dogs",
    textBadge: "Restocked",
    rating: "3.5 ",
    reviews: "6.6K reviews",
    price: 699,
    discountedPrice: 800,
    initialPrice: 1499,
    categoryName: "adult",
    brand: "bayer",
  },
  {
    _id: uuid(),
    name: "DentaStix",
    title: "DentaStix",
    img: dentastix,
    productDesc: "Made with real Apples & Bananas, free of Gluten & Artificial Flavours. Suitable for all Dogs",
    textBadge: "Trending",
    rating: "2.4 ",
    reviews: "8.5K reviews",
    price: 99,
    discountedPrice: 300,
    initialPrice: 399,
    categoryName: "senior",
    brand: "kong",
  },
];